import { useCallback } from 'react'
import { useSnackbar } from '@ui/snackbar'
import { useBlockAction } from '@editorHooks'
import {
  ANCHOR_GRID_BLOCK_ACTION,
  UNSAVED_ANCHOR_GRID_MESSAGE,
  unsavedAnchorGridSnackbarOptions,
} from './constants'

/**
 * Guards closing the Zugverbindertabelle while it has unsaved changes.
 *
 * Returns a function that reports whether the close is blocked: when it is, it shows the
 * "bitte speichern" snackbar and returns `true` (the caller should abort); otherwise `false`.
 * Call it before changing the results mode/state to close the table.
 */
const useAnchorGridCloseGuard = (): (() => boolean) => {
  const { enqueueSnackbar } = useSnackbar()
  const { isBlockedFn: isAnchorGridBlockedFn } = useBlockAction(
    ANCHOR_GRID_BLOCK_ACTION,
    'subscriber',
  )

  return useCallback(() => {
    if (isAnchorGridBlockedFn()) {
      enqueueSnackbar(UNSAVED_ANCHOR_GRID_MESSAGE, unsavedAnchorGridSnackbarOptions)
      return true
    }
    return false
  }, [isAnchorGridBlockedFn, enqueueSnackbar])
}

export default useAnchorGridCloseGuard
